import getDotProp from '../../../utils/getDotProp';
export var getItemId = function getItemId(item, idKeyProp, itemIdx) {
  if (!item) return 'i-' + itemIdx;
  if (item && idKeyProp) return getDotProp(item, idKeyProp);
  return 'i-' + itemIdx;
};
export default {
  getItemId: getItemId
};